import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ProtectedRoutes({ children }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      console.log('No token found');
      navigate('/login');
    }
  }, [navigate]);

  if (!localStorage.getItem('token')) {
    return null; // Return null to avoid rendering children before navigation
  }

  return children;
}